export default __webpack_public_path__ + "public/media/qr-code-android.5a877459.webp";